import { RouteLoading } from "components/telenor/loading";
import Loadable from "react-loadable";

export const StackNameDisplay = Loadable({
  loader: () =>
    import(/* webpackChunkName: "development"*/ "./stack_name_display"),
  loading: RouteLoading
});
